<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header 
    [currentUser]="currentUser" 
    (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav 
      [isMobileMenuOpen]="isMobileMenuOpen"
      (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">จัดการการสอบ</h1>
          <p class="page-subtitle">ระบบจัดการข้อมูลการสอบ VAT</p>
        </div>

        <!-- Mock Data Warning -->
        <ngb-alert 
          *ngIf="showMockDataWarning" 
          type="info" 
          [dismissible]="false"
          class="mb-3">
          <strong>ข้อมูลตัวอย่าง:</strong> 
          ระบบกำลังใช้ข้อมูลตัวอย่างเนื่องจากไม่สามารถเชื่อมต่อ backend API ได้
        </ngb-alert>

        <!-- Error Alert -->
        <ngb-alert 
          *ngIf="error" 
          type="danger" 
          [dismissible]="true"
          class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรอง</h3>
            <div class="filters-actions">
              <button 
                type="button" 
                class="btn btn-success btn-create-exam"
                (click)="openCreateExamModal()"
                ngbTooltip="สร้างการสอบใหม่">
                <i class="bi bi-plus-circle me-2"></i>
                สร้างการสอบ
              </button>
              <button 
                type="button" 
                class="btn btn-outline-secondary btn-sm"
                (click)="clearFilters()">
                <i class="fas fa-times"></i>
                ล้างตัวกรอง
              </button>
            </div>
          </div>

          <div class="filters-content">
            <div class="row g-3">
              <!-- Search Term -->
              <div class="col-md-4">
                <label for="searchTerm" class="form-label">ค้นหาการสอบ</label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="searchTerm"
                  [(ngModel)]="filters.searchTerm"
                  placeholder="ชื่อการสอบ, คำอธิบาย..."
                  (keyup.enter)="applyFilters()">
              </div>

              <!-- Category Filter -->
              <div class="col-md-3">
                <label for="category" class="form-label">หมวดหมู่</label>
                <select 
                  class="form-select" 
                  id="category"
                  [(ngModel)]="filters.category">
                  <option value="">ทั้งหมด</option>
                  <option value="Accounting">Accounting</option>
                  <option value="Tax">Tax</option>
                  <option value="Audit">Audit</option>
                  <option value="Technology">Technology</option>
                  <option value="Cost Accounting">Cost Accounting</option>
                  <option value="Financial Analysis">Financial Analysis</option>
                  <option value="Standards">Standards</option>
                  <option value="Ethics">Ethics</option>
                  <option value="Financial Reporting">Financial Reporting</option>
                  <option value="Management Accounting">Management Accounting</option>
                </select>
              </div>

              <!-- Level Filter -->
              <div class="col-md-3">
                <label for="level" class="form-label">ระดับผู้ประเมิน</label>
                <select 
                  class="form-select" 
                  id="level"
                  [(ngModel)]="filters.level">
                  <option value="">ทั้งหมด</option>
                  <option value="ระดับ 1">ระดับ 1</option>
                  <option value="ระดับ 2">ระดับ 2</option>
                  <option value="ระดับ 3">ระดับ 3</option>
                  <option value="เฉพาะทาง">เฉพาะทาง</option>
                  <option value="ทุกระดับ">ทุกระดับ</option>
                </select>
              </div>

              <!-- Status Filter -->
              <div class="col-md-2">
                <label for="status" class="form-label">สถานะ</label>
                <select 
                  class="form-select" 
                  id="status"
                  [(ngModel)]="filters.status">
                  <option value="">ทั้งหมด</option>
                  <option value="เตรียมเปิดสอบ">เตรียมเปิดสอบ</option>
                  <option value="เปิดรับสมัคร">เปิดรับสมัคร</option>
                  <option value="ปิดรับสมัคร">ปิดรับสมัคร</option>
                  <option value="สอบเสร็จสิ้น">สอบเสร็จสิ้น</option>
                </select>
              </div>
            </div>

            <div class="row g-3 mt-2">
              <!-- Apply Filters Button -->
              <div class="col-md-12 d-flex align-items-end">
                <button 
                  type="button" 
                  class="btn btn-primary"
                  (click)="applyFilters()">
                  <i class="fas fa-search"></i>
                  ค้นหา
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Results Section -->
        <div class="results-section">
          <div class="results-header">
            <h3>ผลการค้นหา</h3>
            <div class="results-meta">
              <span class="result-count">
                พบ {{ collectionSize }} การสอบ
                <span *ngIf="page > 1 || collectionSize > pageSize">
                  (แสดงหน้า {{ page }} จาก {{ Math.ceil(collectionSize / pageSize) }})
                </span>
              </span>
              <small class="text-muted d-block mt-1">
                <i class="fas fa-info-circle me-1"></i>
                คลิกที่แถวเพื่อดูรายละเอียดการสอบ
              </small>
            </div>
          </div>

          <!-- Loading State -->
          <div *ngIf="isLoading" class="loading-state">
            <div class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">กำลังโหลด...</span>
              </div>
              <p class="mt-2 text-muted">กำลังโหลดข้อมูลการสอบ...</p>
            </div>
          </div>

          <!-- No Results -->
          <div *ngIf="!isLoading && filteredExams.length === 0" class="no-results">
            <div class="text-center py-5">
              <i class="fas fa-clipboard-list fa-3x text-muted mb-3"></i>
              <h5 class="text-muted">ไม่พบการสอบที่ตรงตามเงื่อนไข</h5>
              <p class="text-muted">ลองปรับเปลี่ยนเงื่อนไขการค้นหาหรือล้างตัวกรอง</p>
              <button class="btn btn-outline-primary" (click)="clearFilters()">
                <i class="fas fa-refresh"></i>
                ล้างตัวกรอง
              </button>
            </div>
          </div>

          <!-- Exams Table -->
          <div *ngIf="!isLoading && filteredExams.length > 0" class="table-container">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead class="table-dark">
                  <tr>
                    <th scope="col" class="sortable-header" (click)="onSort('examTitle')">
                      ชื่อการสอบ
                      <i [class]="getSortIcon('examTitle')"></i>
                    </th>
                    <th scope="col" class="sortable-header" (click)="onSort('registrationDeadline')">
                      วันที่รับสมัคร
                      <i [class]="getSortIcon('registrationDeadline')"></i>
                    </th>
                    <th scope="col" class="sortable-header" (click)="onSort('examFee')">
                      ราคา
                      <i [class]="getSortIcon('examFee')"></i>
                    </th>
                    <th scope="col" class="sortable-header" (click)="onSort('examDate')">
                      วันที่สอบ
                      <i [class]="getSortIcon('examDate')"></i>
                    </th>

                    <th scope="col" class="sortable-header" (click)="onSort('examDate')">
                      เวลา
                      <i [class]="getSortIcon('examDate')"></i>
                    </th>
                    <th scope="col" class="sortable-header" (click)="onSort('status')">
                      สถานะ
                      <i [class]="getSortIcon('status')"></i>
                    </th>
                    <th scope="col" class="text-center">การดำเนินการ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let exam of getPaginatedExams(); trackBy: trackByExamId" 
                      class="clickable-row" 
                      (click)="editExam(exam)"
                      [attr.title]="'คลิกเพื่อแก้ไขการสอบ: ' + exam.examTitle">
                    <td>
                      <div class="exam-info">
                        <div class="exam-title">{{ exam.examTitle }}</div>
                        <div class="exam-description text-muted">{{ exam.remarks }}</div>
                      </div>
                    </td>
                    <td>{{ formatDate(exam.registrationDeadline) }}</td>
                    <td>{{ formatCurrency(exam.examFee) }}</td>
                    <td>{{ formatDate(exam.examDate) }}</td>

                    <td class="text-center">
                      <div class="text-muted small">{{ exam.examTime || '-' }}</div>
                    </td>
                    <td>
                      <span [class]="getStatusBadgeClass(exam.examStatus)">
                        {{ getStatusText(exam.examStatus) }}
                      </span>
                    </td>
                    <td class="text-center action-cell" (click)="$event.stopPropagation()">
                      <div ngbDropdown 
                           class="d-inline-block action-dropdown" 
                           (click)="$event.stopPropagation()"
                           (openChange)="onDropdownOpenChange($event, exam.id)"
                           container="body"
                           placement="bottom-end">
                        <button 
                          class="btn btn-sm btn-outline-primary dropdown-toggle" 
                          type="button" 
                          id="dropdownMenuButton-{{exam.id}}"
                          ngbDropdownToggle>
                          <i class="fas fa-cog me-1"></i>จัดการ
                        </button>
                        <div class="dropdown-menu" 
                             ngbDropdownMenu 
                             [attr.aria-labelledby]="'dropdownMenuButton-' + exam.id">
                          <button 
                            class="dropdown-item"
                            type="button"
                            (click)="editExam(exam)">
                            <i class="fas fa-edit me-2"></i>แก้ไขการสอบ
                          </button>
                          <div class="dropdown-divider"></div>
                          <button 
                            class="dropdown-item text-danger"
                            type="button"
                            (click)="deleteExam(exam)">
                            <i class="fas fa-trash me-2"></i>ลบการสอบ
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex align-items-center justify-content-end gap-2 mb-2">
              <span class="text-muted small">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
              </select>
            </div>

            <!-- Pagination -->
            <div *ngIf="collectionSize > pageSize" class="d-flex justify-content-center mt-4">
              <ngb-pagination
                [(page)]="page"
                [pageSize]="pageSize"
                [collectionSize]="collectionSize"
                [maxSize]="5"
                [rotate]="true"
                [boundaryLinks]="true"
                (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
